import React from 'react';
import { useTranslate } from 'app/translations';
import { selfKey } from 'utilities/names';

const Style = {
    container: 'flex flex-wrap w-full',
};

export const Description = ({ isSelf }) => {
    const { _t } = useTranslate();
    return (
        <div className={Style.container}>
            <span className="text-primary-700">
                {_t(selfKey('ticket.history.event.description.updated', isSelf)).toLowerCase()}
            </span>
        </div>
    );
};
